import { DialogButtonsConfig } from './dialog-choice';
export interface AlertDialogData {
  type: AlertDialogType;
  title: string;
  description: string;
  useButtons?: DialogButtonsConfig[];
}

export type AlertDialogType =
  | 'ERROR_ALERT'
  | 'WARN_ALERT'
  | 'SUCCESS_ALERT'
  | 'INFO_ALERT';
